(() => {
  if (customElements.get('fp-product-carousel')) return;

  customElements.define('fp-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fp-products__track');
      this.controls = this.querySelector('.fp-products__controls');
      if (!this.track || !this.controls || this.classList.contains('fp-products__carousel--grid')) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = [...this.track.children];
      this.previous = this.querySelector('[data-products-step="-1"]');
      this.next = this.querySelector('[data-products-step="1"]');
      this.position = this.querySelector('.fp-products__position');
      this.previous.addEventListener('click', () => this.step(-1), options);
      this.next.addEventListener('click', () => this.step(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || this.controls.hidden) return;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step((event.key === 'ArrowRight' ? 1 : -1) * direction);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.moveTo(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, options);
      this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive:true });
      this.resize = new ResizeObserver(() => this.schedule());
      this.resize.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    }

    update() {
      const bounds = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const edges = this.cards.map(card => card.getBoundingClientRect());
      this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      this.track.tabIndex = this.controls.hidden ? -1 : 0;
      this.previous.disabled = rtl ? edges[0].right <= bounds.right + 3 : edges[0].left >= bounds.left - 3;
      this.next.disabled = rtl ? edges.at(-1).left >= bounds.left - 3 : edges.at(-1).right <= bounds.right + 3;
      const visible = edges.map((edge, index) => {
        const overlap = Math.min(edge.right, bounds.right) - Math.max(edge.left, bounds.left);
        return overlap > Math.min(edge.width / 2, bounds.width / 2) ? index : -1;
      }).filter(index => index >= 0);
      this.current = visible[0] ?? 0;
      if (visible.length) {
        const first = visible[0] + 1;
        const last = visible.at(-1) + 1;
        const label = `${first === last ? first : `${first}-${last}`} / ${this.cards.length}`;
        if (this.position.textContent !== label) this.position.textContent = label;
      }
    }

    step(direction) {
      this.moveTo(Math.max(0, Math.min(this.cards.length - 1, this.current + direction)));
    }

    moveTo(index) {
      const bounds = this.track.getBoundingClientRect();
      const card = this.cards[index].getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const offset = rtl ? card.right - bounds.right : card.left - bounds.left;
      this.track.scrollBy({
        left:offset,
        behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  });
})();

document.addEventListener('submit', event => {
  const form = event.target.closest?.('[data-product-card-add]');
  if (!form || !window.fetch || !document.getElementById('cartSidebar')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const button = form.querySelector('button');
  if (button.disabled) return;
  button.disabled = true;
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
    .then(response => { if (!response.ok) throw new Error('add failed'); })
    .then(() => {
      const open = () => { if (window.jQuery?.fn.foundation) window.jQuery('#cartSidebar').foundation('open'); };
      if (window.ajaxCart?.load && window.jQuery) {
        window.jQuery(document.body).one('afterCartLoad.ajaxCart', open);
        window.ajaxCart.load();
      } else open();
    })
    .catch(() => form.submit())
    .finally(() => { button.disabled = false; });
}, true);

(() => {
  if (window.fluxposeQuickConfigure || typeof HTMLDialogElement !== 'function' || !window.fetch) return;
  window.fluxposeQuickConfigure = true;
  let dialog, body, opener, loadedUrl = '', request = 0;
  const openCart = () => {
    const open = () => { if (window.jQuery?.fn.foundation && document.getElementById('cartSidebar')) window.jQuery('#cartSidebar').foundation('open'); };
    if (window.ajaxCart?.load && window.jQuery) {
      window.jQuery(document.body).one('afterCartLoad.ajaxCart', open);
      window.ajaxCart.load();
    } else open();
  };
  const key = src => { try { const url = new URL(src, location.href); return url.origin + url.pathname; } catch (error) { return src; } };
  const present = selector => new Set([...document.querySelectorAll(selector)].map(node => key(node.src || node.href)));
  const loadScript = source => new Promise(resolve => {
    const script = document.createElement('script');
    [...source.attributes].forEach(attribute => { if (attribute.name !== 'defer' && attribute.name !== 'async') script.setAttribute(attribute.name, attribute.value); });
    const src = source.getAttribute('src');
    if (src) {
      script.async = false;
      script.onload = script.onerror = () => resolve();
    } else script.textContent = source.textContent;
    source.replaceWith(script);
    if (!src) resolve();
  });
  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'fp-quick-configure';
    dialog.innerHTML = '<div class="fp-quick-configure__bar"><a class="fp-btn fp-btn--outline fp-quick-configure__page" href="#"><span data-open-label></span><span class="fp-arrow" aria-hidden="true"></span></a>' +
      '<button type="button" class="fp-btn fp-btn--ghost fp-btn--icon fp-quick-configure__close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="fp-quick-configure__body"><div class="fp-quick-configure__loading" aria-hidden="true"><span></span><span></span></div><div class="fp-quick-configure__content"></div></div>';
    document.body.append(dialog);
    body = dialog.querySelector('.fp-quick-configure__content');
    dialog.querySelector('.fp-quick-configure__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('fp-quick-open');
      body.querySelector('fp-product-gallery')?.stopAutoplay?.();
      opener?.focus();
    });
    window.jQuery?.(document).on('opened.zf.offcanvas', '#cartSidebar', () => { if (dialog.open) dialog.close(); });
    window.jQuery?.(document.body).on('afterAddItem.ajaxCart', () => { if (dialog.open) dialog.close(); });
    dialog.addEventListener('submit', event => {
      const form = event.target;
      if (event.defaultPrevented || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(response => { if (!response.ok) throw new Error('add failed'); dialog.close(); openCart(); })
        .catch(() => form.submit())
        .finally(() => { if (button) button.disabled = false; });
    });
  };
  const show = async url => {
    const id = ++request;
    dialog.classList.remove('is-loaded');
    const html = await fetch(url, { credentials: 'same-origin' }).then(response => { if (!response.ok) throw new Error('quick view ' + response.status); return response.text(); });
    if (id !== request) return;
    const page = new DOMParser().parseFromString(html, 'text/html');
    const main = page.querySelector('#MainContent');
    if (!main) throw new Error('quick view has no product');
    const styles = present('link[rel="stylesheet"]');
    page.querySelectorAll('head link[rel="stylesheet"]').forEach(link => { if (!styles.has(key(link.getAttribute('href')))) document.head.append(link.cloneNode()); });
    const scripts = present('script[src]');
    const headScripts = [...page.querySelectorAll('head script[src]')].map(script => script.getAttribute('src')).filter(src => !scripts.has(key(src)) && /fluxpose-product-page/.test(src));
    const loaded = present('script[src]');
    body.replaceChildren(...main.childNodes);
    loadedUrl = url;
    for (const script of headScripts) {
      await new Promise(resolve => {
        const holder = document.createElement('script');
        holder.src = script;
        holder.onload = holder.onerror = () => resolve();
        document.head.append(holder);
      });
    }
    for (const script of [...body.querySelectorAll('script')]) {
      if (script.type && !/javascript|module/.test(script.type)) continue;
      if (script.getAttribute('src') && loaded.has(key(script.getAttribute('src')))) { script.remove(); continue; }
      await loadScript(script);
    }
    if (id === request) dialog.classList.add('is-loaded');
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-quick-configure]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (matchMedia('(max-width: 899px)').matches) return;
    event.preventDefault();
    if (!dialog) build();
    opener = link;
    const url = new URL(link.href, location.href);
    url.searchParams.set('view', 'quick');
    dialog.setAttribute('aria-label', link.getAttribute('aria-label') || link.textContent.trim());
    dialog.querySelector('.fp-quick-configure__page').href = link.href;
    dialog.querySelector('[data-open-label]').textContent = link.dataset.quickOpenLabel;
    dialog.querySelector('.fp-quick-configure__close').setAttribute('aria-label', link.dataset.quickCloseLabel);
    document.documentElement.classList.add('fp-quick-open');
    dialog.showModal();
    dialog.querySelector('.fp-quick-configure__close').focus();
    dialog.querySelector('.fp-quick-configure__body').scrollTop = 0;
    if (url.href === loadedUrl && dialog.classList.contains('is-loaded')) return;
    show(url.href).catch(() => { location.href = link.href; });
  });
})();
